import React from 'react';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import styles from './PageHeader.module.scss';
import { cx } from '../../../utils/cx';

export interface Crumb {
    label: string;
    to?: string;
}

interface PageHeaderProps {
    crumbs?: Crumb[];
    title: string;
    meta?: ReactNode[];
    actions?: ReactNode;
    className?: string;
}

export function PageHeader({ crumbs, title, meta, actions, className }: PageHeaderProps) {
    return (
        <div className={cx(styles.head, className)}>
            <div className={styles.main}>
                <h1>{title}</h1>

                {meta && meta.length > 0 && (
                    <p className={styles.sub}>
                        {meta.filter(Boolean).map((item, index) => (
                            <React.Fragment key={index}>
                                {index > 0 && <span className={styles.dot}> · </span>}
                                {item}
                            </React.Fragment>
                        ))}
                    </p>
                )}
            </div>

            {actions && <div className={styles.actions}>{actions}</div>}
        </div>
    );
}